import { EditIconButton, Grid, Stack } from '@razz-team/ui-web';
import { AccountSummary } from './AccountSummary';
import { AccountRequisitesIsland } from '../../Account/AccountRequisitesIsland';
import { LastTransactions } from './LastTransactions';
import { MainLayout } from '../../Layout/MainLayout';
import { Route } from '../../../routes/account.$accountId';
import { MainBreadcrumbs } from '../../Layout/MainBreadcrumbs';
import { useAccountQuery } from '../../../api/accounts';
import { useTranslation } from 'react-i18next';
import { useHasRole } from '../../../api/access';
import { AccountExchangeRate } from './AccountExchangeRate';

export function AccountPage() {
  const { t } = useTranslation();
  const { accountId } = Route.useParams();
  const isAdmin = useHasRole('ADMIN');
  const accountQuery = useAccountQuery({ accountId });

  return (
    <MainLayout
      title={
        <MainBreadcrumbs
          title={accountQuery.data?.name ?? accountQuery.data?.balance.currency ?? t('Account')}
          action={
            isAdmin ? (
              <EditIconButton
                title={t('Update account name')}
                to="/account/$accountId/name"
                params={{ accountId }}
              />
            ) : null
          }
          loading={accountQuery.isPending}
          parent={{
            to: '/account/home',
            title: t('Home'),
          }}
        />
      }
    >
      <Grid size={12}>
        <AccountSummary accountId={accountId} />
      </Grid>
      <Grid size={{ sm: 6, xs: 12 }}>
        <Stack spacing={2} width="100%">
          <AccountExchangeRate accountId={accountId} />
          <AccountRequisitesIsland accountId={accountId} />
        </Stack>
      </Grid>
      <Grid size={{ sm: 6, xs: 12 }}>
        <LastTransactions accountId={accountId} />
      </Grid>
    </MainLayout>
  );
}
